const ActionTypes = {
  GET_CANVAS_SCALE: "GET_CANVAS_SCALE",
  CANVAS_SCALE_CHANGED: "CANVAS_SCALE_CHANGED",
  RESET_CANVAS: "RESET_CANVAS",
  ENABLE_PINCH_ZOOM: "ENABLE_PINCH_ZOOM",
  DISABLE_PINCH_ZOOM: "DISABLE_PINCH_ZOOM",
  CHANGE_LAYOUT: "CHANGE_LAYOUT",
  UPDATE_ALL_ITEMS: "UPDATE_ALL_ITEMS",
  USER_IS_LOGGED_IN: "USER_IS_LOGGED_IN",
  USER_POPUP_CLOSED: "USER_POPUP_CLOSED",
  REMOVE_GREEN_ZONE_ON_CANVAS: "REMOVE_GREEN_ZONE_ON_CANVAS",
  FEATURE_IS_CLICKED: "FEATURE_IS_CLICKED",
  OPEN_MOBILE_NAVIGATION: "OPEN_MOBILE_NAVIGATION",
  CHANGE_MOBILE_MENU_CONTENT_TYPE: "CHANGE_MOBILE_MENU_CONTENT_TYPE",
  UPDATE_QUOTING_TOOL: "UPDATE_QUOTING_TOOL",
  /*** OLD QT ACTIONS***/
  SHOW_NUMERIC_KBD: "SHOW_NUMERIC_KBD",
  OVERLAY_CLICK: "OVERLAY_CLICK",
  SHOW_SUMMARY: null,
  SHOW_DOCUSIGN: 'SHOW_DOCUSIGN'
}
export default ActionTypes;
